// extracted by mini-css-extract-plugin
export var contentBody = "_bi-9";
export var headerImage = "_bi-2";
export var imageButton = "_bi-7";
export var imageButtonIcon = "_bi-8";
export var imageHeader = "_bi-4";
export var imageHeaderText = "_bi-5";
export var imageOverlay = "_bi-3";
export var imageTitle = "_bi-6";
export var imageWrapper = "_bi-1";
export var taskList = "_bi-a";
export var widget = "_bi-0";